import { CommonKey } from '../../../types/api';
import { ClientRightsholder } from '@app/types/inVenue';
import { useQuery } from '@tanstack/react-query';
import sportsApi from '../../../utils/sportsApi';

type ClientRightsholderInput = {
    clientId: number;
};

const fetchClientRightsholders = async ({
    clientId,
}: ClientRightsholderInput): Promise<ClientRightsholder[]> => {
    if (!clientId) return [];
    const result: any = await sportsApi
        .url(`/clients/${clientId}/crowd-iq/rightsholders`)
        .get()
        .json();
    return result;
};

const useRightsholders = ({ clientId }: ClientRightsholderInput) =>
    useQuery({
        queryKey: [CommonKey.InVenueRightsholders, clientId],
        queryFn: (): Promise<ClientRightsholder[]> => fetchClientRightsholders({ clientId }),
    });

export default useRightsholders;
